import { FirestoreAlertPayloadIdentifiers } from '@weave/schema-gen-ts/dist/schemas/notification/v1/notification_api.pb';
import { UserNotificationSetting } from '@weave/schema-gen-ts/dist/schemas/user-notification-settings/v1/user_notification_settings.pb';
import * as Shared_Notification_Notifications from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { UseMutationOptions, UseQueryOptions } from 'react-query';
import { useMutation } from '@frontend/react-query-helpers';
import { useAppScopeStore, useScopedQuery } from '@frontend/scope';
import * as api from './api';

export const useNotificationSettingsQuery = ({
  opts,
  locationId,
}: {
  opts?: UseQueryOptions<Awaited<ReturnType<typeof api.getAllNotificationSettings>>>;
  locationId?: string;
} = {}) => {
  const query = useScopedQuery({
    queryKey: ['notification-settings', locationId],
    queryFn: () => api.getAllNotificationSettings(locationId || ''),
    ...opts,
  });

  return query;
};

type MutationProps = {
  id: UserNotificationSetting['notificationType'];
  value: UserNotificationSetting['sendNotification'];
  locationId?: string;
};
export const useNotificationSettingsMutation = (opts?: UseMutationOptions<unknown, unknown, MutationProps>) =>
  useMutation({
    mutationFn: ({ id, value, locationId }: MutationProps) => api.setShouldSendNotification(id, value, locationId),
    ...opts,
  });

type MarkAsReadProps = {
  notificationType: Shared_Notification_Notifications.NotificationType;
  identifiers: FirestoreAlertPayloadIdentifiers[];
};
export const useMarkNotificationsAsRead = () => {
  const { selectedLocationIds } = useAppScopeStore();
  return useMutation({
    mutationFn: ({ notificationType, identifiers }: MarkAsReadProps) =>
      api.markNotificationsAsRead({
        locationIds: selectedLocationIds,
        markForAllUsers: true,
        markUnread: false,
        notificationType: notificationType,
        identifiers,
      }),
  });
};
